import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
var propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  headingText: PropTypes.string,
  header: PropTypes.node,
  hoverTransform: PropTypes.oneOf(["clickable", "draggable"]),
  cardSize: PropTypes.oneOf(["default", "small"]),
  padding: PropTypes.string
};

var Card = function Card(_ref) {
  var className = _ref.className,
      children = _ref.children,
      headingText = _ref.headingText,
      header = _ref.header,
      hoverTransform = _ref.hoverTransform,
      _ref$cardSize = _ref.cardSize,
      cardSize = _ref$cardSize === void 0 ? "default" : _ref$cardSize,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? "0px" : _ref$padding;
  var styleClasses = classNames("et--card", "et--card-" + cardSize, hoverTransform && "et--card-" + hoverTransform, className);
  return /*#__PURE__*/React.createElement("div", {
    className: styleClasses
  }, headingText && /*#__PURE__*/React.createElement("h2", {
    className: "et--card--heading",
    style: {
      padding: padding
    }
  }, headingText) || header && /*#__PURE__*/React.createElement("h2", {
    className: "et--card--header-section",
    style: {
      padding: padding
    }
  }, headingText && /*#__PURE__*/React.createElement("span", {
    className: "et--card--heading"
  }, headingText), header && header), /*#__PURE__*/React.createElement("div", {
    className: "et--card--main",
    style: {
      padding: padding
    }
  }, children));
};

Card.propTypes = propTypes;
export default Card;